import React, { useEffect } from 'react'
import LoginLayout from '../../features/auth/layout/LoginLayout'
import Button from '../../common/components/atom/Button/Button'
import { useAuth } from '../../features/auth/hooks'
import useNavigationApp from '../../navigation/useNavigationApp'


export default function NotFoundPage () {
  const  navigate = useNavigationApp()
  const {isLogged} = useAuth()
  useEffect(() => {
    if (!isLogged) {
      navigate.redirectToLoginPage()
    }
  })
  return (
    <LoginLayout centered>
      <h1>404 - Page introuvable </h1>
      <p>Oops, cette page n'existe pas</p>
      <div style={{height: 100}}/>
      <Button label="Retourner à l'accueil" linkTo='/' />
    </LoginLayout>
  )
}
